import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import DynamicTabs from '../common/DynamicTabs';
import {
  SELECT_GEOGRAPHICS_LABEL, SELECT_GEOGRAPHICS_TAB_OPTIONS, GEOGRAPHICS_TOP_NODE_VALUES,
  INITIAL_SELECTED_NODE_STATE, INITIAL_GEOGRAPHIES_COUNT,
} from './GeoMapConstant';
import * as geoMappingActions from '../../actions/geoMappingActions';
import GeomapGrid from './GeomapGrid';
import GeomapSelectedTabContents from './GeomapSelectedTabContents';
import CountyAndZipCodeCategoryDropdown from './CountyAndZipCodeCategoryDropdown';
import CustomDragLayer from './CustomDragLayer';
import {
  getGeoMapTableInfo, getGeoMappingRequestsData,
  extractAllNodes, removeDuplicates, SORT_DIRECTION, sortGeoMapTable,
  addMetaDataToGeoMapTable, getGeographiesCount, getGeoghrapicsData, hasGeoDataInTable,
  updateChildrenCounter, getCountyData, getZipcodeData, hasGeoDataInTab,
} from '../../util/geomapUtils';
import Modal from '../common/Modal/Modal';
import GenericButton from '../common/GenericButton';
import CustomSpinner from '../common/CustomSpinner';
import { addIndexToGeoMapData } from '../../util/heatMapUtil';

export const removeGeoMapPillModal = {
  ref: null,
  dialogStyles: {
    width: '328px',
    height: '218px',
    top: '28%',
    left: '40%',
  },
  pillToDelete: null,
};

class GeoMapViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // selectedGeographicsTabIndex: this.props.selectedGeographicsTabIndex,
      // selectedSecondOption: 0,
      renderDropdownData: this.props.geographicsData.censusRegion,
      activeParentNodes: [],
      selectedNodes: INITIAL_SELECTED_NODE_STATE,
      selectAllLabel: this.getGeographyName(
        SELECT_GEOGRAPHICS_TAB_OPTIONS[this.props.selectedGeographicsTabIndex].value),
      // row: [],
      // ctrlSelectedNode: [],
      shiftSelectedNode: [],
      // selectedNodeRange: [],
      baseNodeId: -1,
      lastNodeId: -1,
      firstSelectedNode: -1,
      lastSelectedNode: -1,
      // baseParentNode: -1,
      // allGeoNodesToCompare: INITIAL_SELECTED_NODE_STATE,
      activeGeoMapTable: [],
      localGeographiesCount: INITIAL_GEOGRAPHIES_COUNT,
      isLoading: false,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    if (
      this.props &&
      this.props.geographicsTableData &&
      Object.keys(this.props.geographicsTableData).length > 0
    ) {
      const {
        selectedGeographicsTabIndex,
      } = this.props;
      const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
        .value;
      const geographicsData = _.cloneDeep(this.props.geographicsTableData);
      const geographiesSortOrder = _.cloneDeep(this.props.geographicsSortOrder);
      let activeGeoMapTable = addMetaDataToGeoMapTable(geographicsData[selectedTab]);
      const activeGeoMapSortOrder = geographiesSortOrder[selectedTab];
      if (activeGeoMapTable) {
        if (
          activeGeoMapSortOrder.sortOrder &&
          activeGeoMapSortOrder.sortOrder !== SORT_DIRECTION.NONE
        ) {
          activeGeoMapTable = sortGeoMapTable(
            activeGeoMapSortOrder,
            activeGeoMapTable,
            selectedGeographicsTabIndex
          );
        }
        this.setState(
          {
            activeGeoMapTable,
          },
        );
      }
    }
  }

  componentDidMount() {
    // get region data...
    const { activeAccountId, loginResponse, geoMapStudy } = this.props;
    if (geoMapStudy !== undefined && hasGeoDataInTab(this.props.geographicsData)) {
      getGeoghrapicsData(activeAccountId, loginResponse, geoMapStudy,
        this.props.geoMappingActions.getGeoghrapicsData);
      getCountyData(activeAccountId, loginResponse, geoMapStudy,
        this.props.geoMappingActions.getGeoghrapicsData);
      getZipcodeData(activeAccountId, loginResponse, geoMapStudy,
        this.props.geoMappingActions.getGeoghrapicsData);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      !_.isEqual(this.props.geographicsData, nextProps.geographicsData)
    ) {
      this.setState({
        renderDropdownData: nextProps.geographicsData,
      });
    }
    if (
      !_.isEqual(this.props.selectedGeographicsTabIndex, nextProps.selectedGeographicsTabIndex)
    ) {
      const {
        selectedGeographicsTabIndex,
      } = nextProps;
      const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
        .value;
      const geographicsTableDataList = _.cloneDeep(nextProps.geographicsTableData);
      const geographiesSortOrder = _.cloneDeep(nextProps.geographicsSortOrder);
      let activeGeoMapTable = addMetaDataToGeoMapTable(geographicsTableDataList[selectedTab]);
      const activeGeoMapSortOrder = geographiesSortOrder[selectedTab];
      if (activeGeoMapTable) {
        if (
          activeGeoMapSortOrder.sortOrder &&
          activeGeoMapSortOrder.sortOrder !== SORT_DIRECTION.NONE
        ) {
          activeGeoMapTable = sortGeoMapTable(
            activeGeoMapSortOrder,
            activeGeoMapTable,
            selectedGeographicsTabIndex
          );
        }
        this.setState(
          {
            activeGeoMapTable,
          },
        );
      }
      if (nextProps.geographicsTableApiQueues[selectedTab].length === 0) {
        this.setState({ isLoading: false });
      }

      if (hasGeoDataInTable(nextProps.geographicsTableData)) {
        if (nextProps.geographicsTableApiQueues[selectedTab].length > 0) {
          this.setState({ isLoading: true });
        }
      }
    } else if (
      nextProps.geographicsTableData &&
      Object.keys(nextProps.geographicsTableData).length > 0
    ) {
      const {
        selectedGeographicsTabIndex,
      } = this.props;
      const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
        .value;
      const geographicsTableDataList = _.cloneDeep(nextProps.geographicsTableData);
      const geographiesSortOrder = _.cloneDeep(nextProps.geographicsSortOrder);
      let activeGeoMapTable = addMetaDataToGeoMapTable(geographicsTableDataList[selectedTab]);
      const activeGeoMapSortOrder = geographiesSortOrder[selectedTab];
      if (activeGeoMapTable) {
        if (
          activeGeoMapSortOrder.sortOrder &&
          activeGeoMapSortOrder.sortOrder !== SORT_DIRECTION.NONE
        ) {
          activeGeoMapTable = sortGeoMapTable(
            activeGeoMapSortOrder,
            activeGeoMapTable,
            selectedGeographicsTabIndex
          );
        }
        this.setState(
          {
            activeGeoMapTable,
          },
        );
      }
      if (nextProps.geographicsTableApiQueues[selectedTab].length === 0) {
        this.setState({ isLoading: false });
      }

      if (hasGeoDataInTable(nextProps.geographicsTableData)) {
        if (nextProps.geographicsTableApiQueues[selectedTab].length > 0) {
          this.setState({ isLoading: true });
        }
      }
    }
  }

  shouldComponentUpdate(nextProps, prevState) {
    return !_.isEqual(nextProps, this.props) ||
      !_.isEqual(prevState.selectedNodes, this.state.selectedNodes) ||
      !_.isEqual(prevState.activeParentNodes, this.state.activeParentNodes) ||
      !_.isEqual(prevState.localGeographiesCount, this.state.localGeographiesCount) ||
      !_.isEqual(prevState.isLoading, this.state.isLoading);
  }

  getNodeVal = selectedGeographicsTabIndex => {
    const { countyCategorySelectedVal, zipcodeCategorySelectedVal } = this.props;
    let nodeVal = '';
    const selectedGeographicsVal = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
      .value;
    const selectedTopNodeObj = GEOGRAPHICS_TOP_NODE_VALUES[selectedGeographicsTabIndex];
    if (selectedGeographicsVal === 'county' || selectedGeographicsVal === 'zipcode') {
      const countyNodeObj = _.find(GEOGRAPHICS_TOP_NODE_VALUES, countyCategorySelectedVal);
      const zipcodeNodeObj = _.find(GEOGRAPHICS_TOP_NODE_VALUES, zipcodeCategorySelectedVal);
      nodeVal = selectedGeographicsVal === 'county' ? countyNodeObj[countyCategorySelectedVal]
        : zipcodeNodeObj[zipcodeCategorySelectedVal];
    } else {
      nodeVal = selectedTopNodeObj[selectedGeographicsVal];
    }
    return nodeVal;
  }

  toggleParentNode = toggledNode => {
    if (this.state.activeParentNodes.includes(toggledNode.id)) {
      const activeParentNodes = _.filter(
        this.state.activeParentNodes,
        e => e !== toggledNode.id
      );
      this.setState({ activeParentNodes });
    } else {
      this.setState({
        activeParentNodes: [...this.state.activeParentNodes, toggledNode.id],
      });
    }
  }

  renderSelectedGeographicsPills = () => {
    const { geographicsTableData } = this.props;
    const censusRegionCount = geographicsTableData.censusRegion &&
      geographicsTableData.censusRegion.length;
    const stateCount = geographicsTableData.state && geographicsTableData.state.length;
    const marketCount = geographicsTableData.market && geographicsTableData.market.length;
    const countyCount = geographicsTableData.county && geographicsTableData.county.length;
    const zipcodeCount = geographicsTableData.county && geographicsTableData.zipcode.length;
    return (
      <div id="currentSectionBox" className="large-12 medium-12 small-12 columns">
        <span id="currentSectionBox-SelectionText">
          Current Selections
        </span>
        {censusRegionCount > 0 &&
          <span className="currentSectionBox-SelectionBadge badge">
            Regions {censusRegionCount}
            <button
              type="button"
              aria-label="remove pill"
              className="glyphicon glyphicon-remove float-right"
              onClick={() => {
                removeGeoMapPillModal.pillToDelete = 0;
                removeGeoMapPillModal.ref.show();
              }}
            />
          </span>
        }
        {stateCount > 0 &&
          <span className="currentSectionBox-SelectionBadge badge">
            States {stateCount}
            <button
              type="button"
              aria-label="remove pill"
              className="glyphicon glyphicon-remove float-right"
              onClick={() => {
                removeGeoMapPillModal.pillToDelete = 1;
                removeGeoMapPillModal.ref.show();
              }}
            />
          </span>
        }
        {marketCount > 0 &&
          <span className="currentSectionBox-SelectionBadge badge">
            Markets {marketCount}
            <button
              type="button"
              aria-label="remove pill"
              className="glyphicon glyphicon-remove float-right"
              onClick={() => {
                removeGeoMapPillModal.pillToDelete = 2;
                removeGeoMapPillModal.ref.show();
              }}
            />
          </span>
        }
        {countyCount > 0 &&
          <span className="currentSectionBox-SelectionBadge badge">
            Counties {countyCount}
            <button
              type="button"
              aria-label="remove pill"
              className="glyphicon glyphicon-remove float-right"
              onClick={() => {
                removeGeoMapPillModal.pillToDelete = 3;
                removeGeoMapPillModal.ref.show();
              }}
            />
          </span>
        }
        {zipcodeCount > 0 &&
          <span className="currentSectionBox-SelectionBadge badge">
            Zip Codes {zipcodeCount}
            <button
              type="button"
              aria-label="remove pill"
              className="glyphicon glyphicon-remove float-right"
              onClick={() => {
                removeGeoMapPillModal.pillToDelete = 4;
                removeGeoMapPillModal.ref.show();
              }}
            />
          </span>
        }
      </div>
    );
  }

  renderSelectGeographicsTabData = () => {
    const {
      selectedGeographicsTabIndex,
      geographicsTableData,
      countyCategorySelectedVal,
      zipcodeCategorySelectedVal,
      parentChildCountMap } = this.props;
    const { selectedNodes, activeGeoMapTable } = this.state;
    const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
      .value;
    let selectedTabVal = selectedTab;
    const isMultipleItemSelected = !_.isEmpty(selectedNodes[selectedTab]);
    if (selectedTab === 'county' || selectedTab === 'zipcode') {
      selectedTabVal = selectedTabVal === 'county' ?
        countyCategorySelectedVal : zipcodeCategorySelectedVal;
    }
    const { sortOrder, sortKey, sortColumnIndex } = this.props.geographicsSortOrder[selectedTab];
    return (
      <Fragment>
        {this.renderSelectedGeographicsPills()}
        <div className="column geoMapselectGeographicsBlock">
          <div className="large-3 medium-3 small-3 columns">
            {(selectedTab === 'county' || selectedTab === 'zipcode')
              &&
              <div>
                <CountyAndZipCodeCategoryDropdown
                  selectedTab={selectedTab}
                  clearAll={this.clearAll}
                />
              </div>
            }
            {this.props.geographicsData[selectedTabVal].length > 0 &&
              <div style={{ marginLeft: '2.3%' }}>
                <input
                  type="checkbox"
                  className="all-geo-checkbox"
                  name={selectedTab}
                  onChange={() => this.onSelectAll(selectedTab)}
                  checked={this.isSelectAllChecked(selectedTab)}
                />
                <span className="all-geo-label">{this.state.selectAllLabel}</span>
              </div>}
            <div>
              {isMultipleItemSelected && <CustomDragLayer items={this.getDraggedItems(selectedTab)} />}
              {!_.isEmpty(this.state.renderDropdownData) &&
                <GeomapSelectedTabContents
                  geographicsData={this.props.geographicsData}
                  selectedTab={selectedTab}
                  countyCategorySelectedVal={countyCategorySelectedVal}
                  zipcodeCategorySelectedVal={zipcodeCategorySelectedVal}
                  toggleParentNode={this.toggleParentNode}
                  activeParentNodes={this.state.activeParentNodes}
                  handleDrag={this.handleDrag}
                  handleDrop={this.handleDrop}
                  handleNodeSelection={this.handleNodeSelection}
                  selectedNodes={this.state.selectedNodes}
                  geographicsTableData={geographicsTableData}
                  parentChildCountMap={_.cloneDeep(parentChildCountMap)}
                  isMultipleItemSelected={isMultipleItemSelected}
                  handleInvalidDrop={this.handleInvalidDrop}
                />
              }
            </div>
          </div>
          <div className="large-9 medium-9 small-9 columns">
            <GeomapGrid
              deleteRows={this.deleteRows}
              selectedTabGeographyData={activeGeoMapTable}
              onSort={this.handleSort}
              sortColumnIndex={sortColumnIndex}
              sortKey={sortKey}
              sortOrder={sortOrder}
              selectedTab={selectedTab}
              getGeoTitle={this.getGeoTitle}
            />
            {(((!_.isEmpty(this.props.originalTitles.BaseDataGrid) &&
              !_.isEmpty(this.props.geoMapBase)) &&
              !_.isEqual(this.props.originalTitles.BaseDataGrid.originalTitle,
                this.props.geoMapBase[0].originalTitle)) ||
              ((!_.isEmpty(this.props.originalTitles.TargetDataGrid) &&
                !_.isEmpty(this.props.geoMapTarget)) &&
                !_.isEqual(this.props.originalTitles.TargetDataGrid.originalTitle,
                  this.props.geoMapTarget[0].originalTitle))) &&
              <div className="label-changed-text text-right font-8"><sup>1</sup>Label changed by user</div>}
          </div>
        </div>
      </Fragment>
    );
  };

  extractAllNodes = listNodes => {
    const finalResults = [];
    const extract = listNodes => {
      _.map(listNodes, elem => {
        if (elem.s) {
          finalResults.push(elem);
          extract(elem.s);
        } else {
          finalResults.push(elem);
        }
      });
    };
    extract(listNodes);
    return finalResults;
  }

  getGeoTitle = (geoName, parentId, selectedTab) => {
    const { allGeoNodesToCompare } = this.props;
    const breadCrumb = `${geoName}`;
    const parentArray = parentId.substr(0, parentId.lastIndexOf('.')).split('.').reverse();
    let finalBreadcrumb = '';
    if (selectedTab === 'county' || selectedTab === 'zipcode') {
      _.forEach(parentArray, item => {
        let parentName = '';
        if (selectedTab === 'county') {
          parentName = _.find(allGeoNodesToCompare.countyByMarket,
            elem => elem.id === Number(item));
          parentName = parentName ||
            _.find(allGeoNodesToCompare.countyByState,
              elem => elem.id === Number(item));
        }
        if (selectedTab === 'zipcode') {
          parentName = _.find(allGeoNodesToCompare.zipcodeByMarket,
            elem => elem.id === Number(item));
          parentName = parentName ||
            _.find(allGeoNodesToCompare.zipcodeByState,
              elem => elem.id === Number(item));
        }
        finalBreadcrumb = finalBreadcrumb ? `${finalBreadcrumb} | ${parentName.n}`
          : `| ${parentName.n}`;
      });
      return `${breadCrumb} ${finalBreadcrumb}`;
    }
    return breadCrumb;
  }

  handleInvalidDrop = () => {
    const { selectedGeographicsTabIndex } = this.props;
    const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
      .value;
    const uniqueSelectedNodes = removeDuplicates(this.state.selectedNodes[selectedTab]);
    this.setState({
      selectedNodes: {
        ...this.state.selectedNodes,
        [selectedTab]: [...uniqueSelectedNodes],
      },
      localGeographiesCount: {
        ...this.state.localGeographiesCount,
        [selectedTab]: getGeographiesCount(uniqueSelectedNodes),
      },
      isLoading: false,
    });
  }

  onSelectAll = tabName => {
    const { geographicsTableData, geographicsData,
      countyCategorySelectedVal, zipcodeCategorySelectedVal } = this.props;
    let selectedTabVal = tabName;
    if (tabName === 'county' || tabName === 'zipcode') {
      selectedTabVal = selectedTabVal === 'county' ?
        countyCategorySelectedVal : zipcodeCategorySelectedVal;
    }
    if (this.isSelectAllChecked(tabName)) {
      this.setState(() => ({
        selectedNodes: INITIAL_SELECTED_NODE_STATE,
        localGeographiesCount: INITIAL_GEOGRAPHIES_COUNT,
      }));
    } else {
      const extractedNodes = extractAllNodes(geographicsData[selectedTabVal]);
      const alreadyDragged = [...geographicsTableData[tabName]];
      alreadyDragged.forEach(elem => {
        extractedNodes.forEach((el, index) => {
          if (elem.id === el.id) {
            extractedNodes.splice(index, 1);
          }
        });
      });
      this.setState({
        selectedNodes: {
          ...this.state.selectedNodes,
          [tabName]: [...extractedNodes],
        },
        localGeographiesCount: {
          ...this.state.localGeographiesCount,
          [tabName]: getGeographiesCount(extractedNodes),
        },
      });
    }
  }

  clearAll = () => {
    this.setState(() => ({
      selectedNodes: INITIAL_SELECTED_NODE_STATE,
      localGeographiesCount: INITIAL_GEOGRAPHIES_COUNT,
      // ctrlSelectedRange: [],
      // ctrlSelectedNode: [],
      // selectedNodeRange: [],
      baseNodeId: -1,
      lastNodeId: -1,
      firstSelectedNode: -1,
      lastSelectedNode: -1,
      // baseParentNode: -1,
      shiftSelectedNode: [],
    }));
  }

  createGeoTableObjectWithZeroes = data => {
    const formattedTableDataArr = [];
    _.map(data, obj => {
      const val = `${obj.f} (${obj.id})`;
      const temObj = {
        pid: obj.pid,
        g: obj.n,
        e: val,
        ts: 0,
        tw: 0,
        bw: 0,
        h: 0,
        i: 0,
        sp: obj.sp,
        id: obj.id,
      };
      formattedTableDataArr.push(temObj);
    });
    return formattedTableDataArr;
  }

  handleDrop = e => {
    const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[this.props.selectedGeographicsTabIndex]
      .value;
    const {
      zipcodeCategorySelectedVal,
      countyCategorySelectedVal,
      geographicsTableData,
      geoMapTarget,
    } = this.props;
    let draggableNodes = [];
    draggableNodes = removeDuplicates(e);
    const selectedTabVal = selectedTab;
    draggableNodes = draggableNodes.filter(elem => {
      return (geographicsTableData[selectedTabVal].findIndex(el => el.id === elem.id) === -1);
    });
    const finalListNodes = _.filter(draggableNodes, el => el.f !== undefined);
    this.setState(() => ({
      selectedNodes: {
        ...this.state.selectedNodes,
        [selectedTabVal]: [...draggableNodes],
      },
      localGeographiesCount: INITIAL_GEOGRAPHIES_COUNT,
    }));
    const geoTableDataObjectWithZeroes = this.createGeoTableObjectWithZeroes(
      finalListNodes
    );
    this.props.geoMappingActions.setGeoghrapicsTableDataWithZeros(
      geoTableDataObjectWithZeroes, selectedTabVal)
      .then(() => {
        this.clearAll();
      });
    if (geoMapTarget && geoMapTarget.length > 0) {
      const geoRequests = getGeoMappingRequestsData(geoTableDataObjectWithZeroes);
      this.props.geoMappingActions.setGeoghrapicsApiQueues(geoRequests, selectedTabVal)
        .then(() => {
          const { loginResponse, activeAccountId, geoMapStudy, geoWeightTypes, geoMapTarget,
            selectedGeographicsTabIndex, geographicsTableApiQueues } = this.props;
          getGeoMapTableInfo(
            loginResponse,
            activeAccountId,
            geoMapStudy,
            geoWeightTypes,
            geoMapTarget,
            selectedGeographicsTabIndex,
            countyCategorySelectedVal,
            zipcodeCategorySelectedVal,
            geographicsTableApiQueues,
            this.props.geoMappingActions.getGeoghrapicsTableData,
            this.props.geoMappingActions.setGeoghrapicsTableApiCallStatus,
          );
        });
    } else {
      this.setState({ isLoading: false });
    }
    if (selectedTab === 'county' || selectedTab === 'zipcode') {
      updateChildrenCounter(selectedTab, finalListNodes, false,
        this.props.parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
    }
    setTimeout(() => {
      if (geographicsTableData[selectedTabVal].length > 0) {
        const wrapper = $('.geo-grid');
        wrapper
          .find('.ReactVirtualized__List')
          .scrollTop(
            wrapper.find('.ReactVirtualized__List')[0]
              ? wrapper.find('.ReactVirtualized__List')[0].scrollHeight
              : 0
          );
      }
    }, 1000);
  }

  getGeographyName = selectedTab => {
    switch (selectedTab) {
      case 'censusRegion':
        return 'All Regions';
      case 'state':
        return 'All States';
      case 'market':
        return 'All Markets';
      case 'county':
        return 'All Counties';
      case 'zipcode':
        return 'All Zip Codes';
      default:
        return 'All Regions';
    }
  }

  handleDrag = dragNode => {
    this.setState({ isLoading: true });
    const {
      selectedGeographicsTabIndex,
    } = this.props;
    const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
      .value;
    const selectedTabVal = selectedTab;
    let draggedNodesList = [];
    let draggableNodes = [];
    draggedNodesList = dragNode.s ?
      [...extractAllNodes([dragNode]), dragNode] : [dragNode];
    draggableNodes = [...this.state.selectedNodes[selectedTabVal], ...draggedNodesList];

    this.setState(() => ({
      selectedNodes: {
        ...this.state.selectedNodes,
        [selectedTabVal]: [...draggableNodes],
      },
    }));
    // const nodesToDrag = _.orderBy([...draggableNodes], ['id'],['asc']);
    return [...draggableNodes];
  }

  createSelectionsRange = (selectedTab, nodeWithChildren) => {
    const { baseNodeId, lastNodeId, firstSelectedNode, lastSelectedNode,
      shiftSelectedNode, selectedNodes } = this.state;
    const { geographicsTableData, draggedParentNodes, allGeoNodesToCompare } = this.props;
    const finalNodes = [];
    const recentlySelected = [];
    let range = [];
    let draggableNodes = [];
    let selectedTabVal = selectedTab;
    if (selectedTab === 'county' || selectedTab === 'zipcode') {
      selectedTabVal = selectedTab === 'county' ?
        this.props.countyCategorySelectedVal :
        this.props.zipcodeCategorySelectedVal;
    }
    let baseIndex = baseNodeId;
    const lastNodeParentId = lastSelectedNode.pid.substr(0,
      lastSelectedNode.pid.lastIndexOf('.'));
    const firstNodeParentId = firstSelectedNode.pid.substr(0,
      firstSelectedNode.pid.lastIndexOf('.'));

    _.map(selectedNodes[selectedTab], elem => {
      if (shiftSelectedNode.findIndex(el => elem.pid === el.pid) === -1) {
        finalNodes.push(elem);
      }
    });
    if (baseNodeId <= lastNodeId) {
      range = allGeoNodesToCompare[selectedTabVal].slice(baseNodeId, lastNodeId + 1);
      _.map(range, el => {
        if (finalNodes.findIndex(elem => elem.pid === el.pid) === -1) {
          recentlySelected.push(el);
        }
      });
      draggableNodes = [...finalNodes, ...recentlySelected];
      if (nodeWithChildren) {
        draggableNodes = draggableNodes.slice(0, draggableNodes.length - 1);
        draggableNodes = [...draggableNodes, nodeWithChildren,
        ...extractAllNodes([...nodeWithChildren.s])];
      }
      const lastNodeParent = allGeoNodesToCompare[selectedTabVal]
        .find(el => el.pid === lastNodeParentId);
      if ((lastNodeParent && lastNodeParent.s) || lastNodeParentId.includes('.')) {
        let lastNodeGrandParent;
        if (selectedTab === 'zipcodeByState' && lastSelectedNode.s &&
          lastSelectedNode.pid.includes('.')) {
          let isParentPresent = false;
          if (lastNodeParent) {
            const filteredNodes = _.filter(draggableNodes,
              el => {
                if (el.pid === lastNodeParent.pid) {
                  isParentPresent = true;
                }
                return ((el.pid !== lastNodeParent.pid) &&
                  (el.pid.substr(0, el.pid.lastIndexOf('.')) === lastNodeParent.pid));
              });
            const draggedChildNodes = draggedParentNodes[selectedTab]
              .filter(el => ((el.pid !== lastNodeParent.pid) &&
                (el.pid.substr(0, el.pid.lastIndexOf('.')) === lastNodeParent.pid)));
            const totalSelectedAndDragged = [...filteredNodes,
            ...draggedChildNodes];
            if (lastNodeParent.s.length !== totalSelectedAndDragged.length) {
              draggableNodes = _.filter(draggableNodes,
                el => el.pid !== lastNodeParent.pid);
            } else if (!isParentPresent) {
              draggableNodes = [lastNodeParent, ...draggableNodes];
            }
          }
        } else {
          if (lastNodeParent.pid.includes('.')) {
            const firstNodeGrandParentId = lastNodeParent.pid.substr(0,
              lastNodeParent.pid.lastIndexOf('.'));
            lastNodeGrandParent = allGeoNodesToCompare[selectedTabVal]
              .find(el => el.pid === firstNodeGrandParentId);
          }
          let isParentPresent = false;
          let isGrandParentPresent = false;
          if (lastNodeParent) {
            const filteredNodes = _.filter(draggableNodes,
              el => {
                if (el.pid === lastNodeParent.pid) {
                  isParentPresent = true;
                }
                return ((el.pid !== lastNodeParent.pid) &&
                  (el.pid.substr(0, el.pid.lastIndexOf('.')) === lastNodeParent.pid));
              });
            const draggedChildNodes = geographicsTableData[selectedTab]
              .filter(el => el.pid.startsWith(lastNodeParent.pid));
            const totalSelectedAndDragged = [...filteredNodes,
            ...draggedChildNodes];
            if (lastNodeParent.s.length !== totalSelectedAndDragged.length) {
              draggableNodes = _.filter(draggableNodes,
                el => el.pid !== lastNodeParent.pid);
            } else if (!isParentPresent) {
              draggableNodes = [lastNodeParent, ...draggableNodes];
            }
            if (lastNodeGrandParent) {
              const GrandParentfilteredNodes = _.filter(draggableNodes,
                el => {
                  if (lastNodeGrandParent && el.pid === lastNodeGrandParent.pid) {
                    isGrandParentPresent = true;
                  }
                  return ((el.pid !== lastNodeGrandParent.pid) &&
                    (el.pid.substr(0, el.pid.lastIndexOf('.')) === lastNodeGrandParent.pid));
                });
              const draggedChildNodes = draggedParentNodes[selectedTab]
                .filter(el => ((el.pid !== lastNodeGrandParent.pid) &&
                  (el.pid.substr(0, el.pid.lastIndexOf('.')) === lastNodeGrandParent.pid)));
              const totalSelectedAndDragged = [...GrandParentfilteredNodes,
              ...draggedChildNodes];
              if (lastNodeGrandParent.s.length !== totalSelectedAndDragged.length) {
                draggableNodes = _.filter(draggableNodes,
                  el => el.pid !== lastNodeGrandParent.pid);
              } else if (!isGrandParentPresent) {
                draggableNodes = [lastNodeGrandParent, ...draggableNodes];
                range = [lastNodeGrandParent, ...range];
              }
            }
          }
        }
      }
      if (firstNodeParentId !== lastNodeParentId && firstSelectedNode.pid.includes('.')) {
        let firstNodeGrandParent;
        const firstNodeParent = allGeoNodesToCompare[selectedTabVal]
          .find(el => el.pid === firstNodeParentId);
        if (firstNodeParent.pid.includes('.')) {
          const firstNodeGrandParentId = firstNodeParent.pid.substr(0,
            firstNodeParent.pid.lastIndexOf('.'));
          firstNodeGrandParent = allGeoNodesToCompare[selectedTabVal]
            .find(el => el.pid === firstNodeGrandParentId);
        }
        let isParentPresent = false;
        let isGrandParentPresent = false;
        const filteredNodes = _.filter(draggableNodes,
          el => {
            if (el.pid === firstNodeParent.pid) {
              isParentPresent = true;
            }
            return ((el.pid !== firstNodeParent.pid) &&
              (el.pid.substr(0, el.pid.lastIndexOf('.')) === firstNodeParent.pid));
          });
        if (firstNodeParent.s.length !== filteredNodes.length) {
          draggableNodes = _.filter(draggableNodes,
            el => el.pid !== firstNodeParent.pid);
        } else if (!isParentPresent) {
          draggableNodes = [firstNodeParent, ...draggableNodes];
          range = [firstNodeParent, ...range];
        }
        if (firstNodeGrandParent) {
          const GrandParentfilteredNodes = _.filter(draggableNodes,
            el => {
              if (firstNodeGrandParent && el.pid === firstNodeGrandParent.pid) {
                isGrandParentPresent = true;
              }
              return ((el.pid !== firstNodeGrandParent.pid) &&
                (el.pid.substr(0, el.pid.lastIndexOf('.')) === firstNodeGrandParent.pid));
            });
          if (firstNodeGrandParent.s.length !== GrandParentfilteredNodes.length) {
            draggableNodes = _.filter(draggableNodes,
              el => el.pid !== firstNodeGrandParent.pid);
          } else if (!isGrandParentPresent) {
            draggableNodes = [firstNodeGrandParent, ...draggableNodes];
            range = [firstNodeGrandParent, ...range];
          }
        }
      }
    } else {
      const extractedNodesLenth = extractAllNodes([firstSelectedNode]).length;
      baseIndex = firstSelectedNode.s ?
        baseNodeId + (extractedNodesLenth - 1) : baseNodeId;
      range = allGeoNodesToCompare[selectedTabVal].slice(lastNodeId, baseIndex + 1);
      _.map(range, el => {
        if (finalNodes.findIndex(elem => elem.pid === el.pid) === -1) {
          recentlySelected.push(el);
        }
      });
      draggableNodes = [...finalNodes, ...recentlySelected];
      if (!firstNodeParentId.includes('.')) {
        const firstNodeParent = allGeoNodesToCompare[selectedTabVal]
          .find(el => el.pid === firstNodeParentId);
        let isParentPresent = false;
        if (firstNodeParent) {
          const filteredNodes = _.filter(draggableNodes,
            el => {
              if (el.pid === firstNodeParent.pid) {
                isParentPresent = true;
              }
              return ((el.pid !== firstNodeParent.pid) &&
                (el.pid.substr(0, el.pid.lastIndexOf('.')) === firstNodeParent.pid));
            });
          const draggedChildNodes = geographicsTableData[selectedTab]
            .filter(el => el.pid.startsWith(firstNodeParent.pid));
          const totalSelectedAndDragged = [...filteredNodes,
          ...draggedChildNodes];
          if (firstNodeParent.s.length !== totalSelectedAndDragged.length) {
            draggableNodes = _.filter(draggableNodes,
              el => el.pid !== firstNodeParent.pid);
          } else if (!isParentPresent) {
            draggableNodes = [firstNodeParent, ...draggableNodes];
          }
        }
      } else if (firstNodeParentId !== lastNodeParentId && firstSelectedNode.pid.includes('.')) {
          let firstNodeGrandParent;
          const firstNodeParent = allGeoNodesToCompare[selectedTabVal]
            .find(el => el.pid === firstNodeParentId);
          if (firstNodeParent.pid.includes('.')) {
            const firstNodeGrandParentId = firstNodeParent.pid.substr(0,
              firstNodeParent.pid.lastIndexOf('.'));
            firstNodeGrandParent = allGeoNodesToCompare[selectedTabVal]
              .find(el => el.pid === firstNodeGrandParentId);
          }
          let isParentPresent = false;
          let isGrandParentPresent = false;
          const filteredNodes = _.filter(draggableNodes,
            el => {
              if (el.pid === firstNodeParent.pid) {
                isParentPresent = true;
              }
              return ((el.pid !== firstNodeParent.pid) &&
                (el.pid.substr(0, el.pid.lastIndexOf('.')) === firstNodeParent.pid));
            });
          if (firstNodeParent.s.length !== filteredNodes.length) {
            draggableNodes = _.filter(draggableNodes,
              el => el.pid !== firstNodeParent.pid);
          } else if (!isParentPresent) {
            draggableNodes = [firstNodeParent, ...draggableNodes];
            range = [firstNodeParent, ...range];
          }
          if (firstNodeGrandParent) {
            const GrandParentfilteredNodes = _.filter(draggableNodes,
              el => {
                if (firstNodeGrandParent && el.pid === firstNodeGrandParent.pid) {
                  isGrandParentPresent = true;
                }
                return ((el.pid !== firstNodeGrandParent.pid) &&
                  (el.pid.substr(0, el.pid.lastIndexOf('.')) === firstNodeGrandParent.pid));
              });
            if (firstNodeGrandParent.s.length !== GrandParentfilteredNodes.length) {
              draggableNodes = _.filter(draggableNodes,
                el => el.pid !== firstNodeGrandParent.pid);
            } else if (!isGrandParentPresent) {
              draggableNodes = [firstNodeGrandParent, ...draggableNodes];
              range = [firstNodeGrandParent, ...range];
            }
          }
        }
      if (lastSelectedNode.pid.includes('.')) {
        let lastNodeGrandParent;
        const lastNodeParent = allGeoNodesToCompare[selectedTabVal]
          .find(el => el.pid === lastNodeParentId);
        if (lastNodeParent.pid.includes('.')) {
          const lastNodeGrandParentId = lastNodeParent.pid.substr(0,
            lastNodeParent.pid.lastIndexOf('.'));
          lastNodeGrandParent = allGeoNodesToCompare[selectedTabVal]
            .find(el => el.pid === lastNodeGrandParentId);
        }
        let isParentPresent = false;
        let isGrandParentPresent = false;
        const filteredNodes = _.filter(draggableNodes,
          el => {
            if (el.pid === lastNodeParent.pid) {
              isParentPresent = true;
            }
            return ((el.pid !== lastNodeParent.pid) &&
              (el.pid.substr(0, el.pid.lastIndexOf('.')) === lastNodeParent.pid));
          });
        const draggedChildNodes = geographicsTableData[selectedTab]
          .filter(el => el.pid.startsWith(lastNodeParent.pid));
        const totalSelectedAndDragged = [...filteredNodes,
        ...draggedChildNodes];
        if (lastNodeParent.s.length !== totalSelectedAndDragged.length) {
          draggableNodes = _.filter(draggableNodes,
            el => el.pid !== lastNodeParent.pid);
        } else if (!isParentPresent) {
          draggableNodes = [lastNodeParent, ...draggableNodes];
          range = [lastNodeParent, ...range];
        }
        if (lastNodeGrandParent) {
          const GrandParentfilteredNodes = _.filter(draggableNodes,
            el => {
              if (lastNodeGrandParent && el.pid === lastNodeGrandParent.pid) {
                isGrandParentPresent = true;
              }
              return ((el.pid !== lastNodeGrandParent.pid) &&
                (el.pid.substr(0, el.pid.lastIndexOf('.')) === lastNodeGrandParent.pid));
            });
          const draggedChildNodes = draggedParentNodes[selectedTab]
            .filter(el => ((el.pid !== lastNodeGrandParent.pid) &&
              (el.pid.substr(0, el.pid.lastIndexOf('.')) === lastNodeGrandParent.pid)));
          const totalSelectedAndDragged = [...GrandParentfilteredNodes,
          ...draggedChildNodes];
          if (lastNodeGrandParent.s.length !== totalSelectedAndDragged.length) {
            draggableNodes = _.filter(draggableNodes,
              el => el.pid !== lastNodeGrandParent.pid);
          } else if (!isGrandParentPresent) {
            draggableNodes = [lastNodeGrandParent, ...draggableNodes];
            range = [lastNodeGrandParent, ...range];
          }
        }
      }
    }
    const geoCount = getGeographiesCount(
      [...this.state.selectedNodes[selectedTab], ...draggableNodes]);
    this.setState(() => ({
      shiftSelectedNode: [...extractAllNodes(range)],
      selectedNodes: {
        ...this.state.selectedNodes,
        [selectedTab]: [...draggableNodes],
      },
      localGeographiesCount: {
        ...this.state.localGeographiesCount,
        [selectedTab]: geoCount,
      },
    }));
  }

  handleNodeSelection = (event, node) => {
    const {
      baseNodeId,
      lastNodeId,
      firstSelectedNode,
      lastSelectedNode,
    } = this.state;
    const {
      selectedGeographicsTabIndex,
      geographicsTableData,
      draggedParentNodes,
      allGeoNodesToCompare,
    } = this.props;
    const isCtrl = event.ctrlKey || event.metaKey;
    const isShift = event.shiftKey || (event.shiftKey && isCtrl);
    let baseNode = baseNodeId;
    let lastNode = lastNodeId;
    // let baseParentNode = -1;
    let nodeWithChildren;
    // const parentNode = baseParentNode;
    const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
      .value;
    let slectedTabVal = selectedTab;
    if (selectedTab === 'county' || selectedTab === 'zipcode') {
      slectedTabVal = selectedTab === 'county' ?
        this.props.countyCategorySelectedVal :
        this.props.zipcodeCategorySelectedVal;
    }
    if (isShift) {
      let firstSelected = { ...firstSelectedNode };
      let lastSelected = { ...lastSelectedNode };
      if (node.s && node.pid.includes('.')) {
        let indexOfSelectedNode;
        // const parentId = node.pid.substr(0, node.pid.lastIndexOf('.'));
        _.forEach(allGeoNodesToCompare[slectedTabVal],
          (el, index) => {
            // if (el.pid === parentId) {
            //   baseParentNode = { ...el };
            // }
            if (el.pid === node.pid) {
              indexOfSelectedNode = index;
              nodeWithChildren = { ...el };
            }
          });

        if (baseNode >= 0) {
          lastNode = indexOfSelectedNode;
          lastSelected = { ...node };
        } else {
          baseNode = indexOfSelectedNode;
          lastNode = indexOfSelectedNode;
          firstSelected = { ...node };
          lastSelected = { ...node };
        }
      } else if (node.s && !node.pid.includes('.')) {
        let indexOfSelectedNode;
        _.forEach(allGeoNodesToCompare[slectedTabVal],
          (el, index) => {
            if (el.pid === node.pid) {
              indexOfSelectedNode = index;
            }
          });
        if (baseNode >= 0) {
          lastNode = indexOfSelectedNode;
          nodeWithChildren = { ...node };
          lastSelected = { ...node };
        } else {
          baseNode = indexOfSelectedNode;
          lastNode = indexOfSelectedNode;
          nodeWithChildren = { ...node };
          firstSelected = { ...node };
          lastSelected = { ...node };
        }
      } else if (!node.s && !node.pid.includes('.')) {
        const indexOfSelectedNode = _.findIndex(allGeoNodesToCompare[slectedTabVal],
          el => el.pid === node.pid);
        if (baseNode >= 0) {
          lastNode = indexOfSelectedNode;
          lastSelected = { ...node };
        } else {
          baseNode = indexOfSelectedNode;
          lastNode = indexOfSelectedNode;
          firstSelected = { ...node };
          lastSelected = { ...node };
        }
      } else if (!node.s && node.pid.includes('.')) {
        let indexOfSelectedNode;
        // const parentId = node.pid.substr(0, node.pid.lastIndexOf('.'));
        _.forEach(allGeoNodesToCompare[slectedTabVal],
          (el, index) => {
            // if (el.pid === parentId) {
            //   baseParentNode = { ...el };
            // }
            if (el.pid === node.pid) {
              indexOfSelectedNode = index;
            }
          });

        if (baseNode >= 0) {
          lastNode = indexOfSelectedNode;
          lastSelected = { ...node };
        } else {
          baseNode = indexOfSelectedNode;
          lastNode = indexOfSelectedNode;
          firstSelected = { ...node };
          lastSelected = { ...node };
        }
      }
      this.setState({
        baseNodeId: baseNode,
        lastNodeId: lastNode,
        // baseParentNode,
        firstSelectedNode: firstSelected,
        lastSelectedNode: lastSelected,
      }, () => {
        this.createSelectionsRange(selectedTab, nodeWithChildren);
      });
    } else {
      const selectedNodesList = this.state.selectedNodes[selectedTab];
      let filteredNodes = [];
      if (_.some(selectedNodesList, el => el.id === node.id)) {
        const parentNodes = node.pid.includes('.') ? node.pid.split('.') : [node.pid];
        if (node.s) {
          if (node.pid.includes('.')) {
            const temp = _.filter(selectedNodesList, item => !item.pid.includes(node.pid));
            filteredNodes = _.filter(temp, el => !parentNodes.includes(String(el.id)));
          } else {
            filteredNodes = _.filter(selectedNodesList, item => {
              return !item.pid.split('.').includes(String(node.id));
            });
          }
        } else {
          filteredNodes = _.filter(selectedNodesList, el => !parentNodes.includes(String(el.id)));
        }
        this.setState(() => ({
          shiftSelectedNode: [],
          baseNodeId: -1,
          lastNodeId: -1,
          // baseParentNode: -1,
          firstSelectedNode: -1,
          lastSelectedNode: -1,
          selectedNodes: {
            ...this.state.selectedNodes,
            [selectedTab]: filteredNodes,
          },
          localGeographiesCount: {
            ...this.state.localGeographiesCount,
            [selectedTab]: getGeographiesCount(filteredNodes),
          },
        }));
      } else if (!(_.some(selectedNodesList, el => el.id === node.id)) && node.s) {
        let tempSelection = [...selectedNodesList];
        const parentId = node.pid.substr(0, node.pid.lastIndexOf('.'));
        if (node.pid.includes('.')) {
          const indexOfSelectedNode = _.findIndex(allGeoNodesToCompare[slectedTabVal],
            el => el.pid === node.pid);
          const filteredChildNodes = node.s.filter(el => {
            return (tempSelection.findIndex(elem => elem.pid === el.pid) === -1);
          });
          tempSelection = [...tempSelection, node, ...filteredChildNodes];
          const nodesToSelect = allGeoNodesToCompare[slectedTabVal]
            .filter(el => (el.pid === parentId));
          const secChildNodeList = _.filter(tempSelection, el => {
            return (el.pid.split('.').length === 2 &&
              el.pid.includes(node.pid.substr(0, node.pid.lastIndexOf('.'))));
          });
          const draggedChildNodes = draggedParentNodes[selectedTab]
            .filter(el => (el.pid.split('.').length === 2 &&
              el.pid.includes(parentId.substr(0, parentId.lastIndexOf('.')))));
          const totalSelectedAndDragged = [...secChildNodeList,
          ...draggedChildNodes];
          const secParentNode = nodesToSelect.find(el => el.pid === parentId);
          if (secParentNode.s.length === totalSelectedAndDragged.length) {
            tempSelection = [secParentNode, ...tempSelection];
          }
          this.setState(() => ({
            shiftSelectedNode: [],
            baseNodeId: indexOfSelectedNode,
            lastNodeId: indexOfSelectedNode,
            firstSelectedNode: { ...node },
            lastSelectedNode: { ...node },
            selectedNodes: {
              ...this.state.selectedNodes,
              [selectedTab]: [...tempSelection],
            },
          }), () => {
            this.createSelectionsRange(selectedTab);
          });
        } else {
          let filteredChildNodes = [];
          filteredChildNodes = extractAllNodes([...node.s]).filter(el => {
            return (tempSelection.findIndex(elem => elem.pid === el.pid) === -1);
          });
          const totalDragged = [...geographicsTableData[selectedTab],
          ...draggedParentNodes[selectedTab]];
          if (selectedTab === 'zipcodeByState') {
            if (totalDragged.length && selectedTab === 'zipcodeByState') {
              filteredChildNodes = extractAllNodes([...node.s]).filter(el => {
                return (totalDragged.findIndex(
                  elem => elem.pid === el.pid) === -1);
              });
            }
          } else if (geographicsTableData[selectedTab].length) {
              filteredChildNodes = extractAllNodes([...node.s]).filter(el => {
                return (geographicsTableData[selectedTab].findIndex(
                  elem => elem.pid === el.pid) === -1);
              });
            }
          tempSelection = [...tempSelection, node, ...filteredChildNodes];
          const indexOfSelectedNode = _.findIndex(allGeoNodesToCompare[slectedTabVal],
            el => el.pid === node.pid);
          this.setState(() => ({
            shiftSelectedNode: [],
            baseNodeId: indexOfSelectedNode,
            lastNodeId: indexOfSelectedNode,
            firstSelectedNode: { ...node },
            lastSelectedNode: { ...node },
            selectedNodes: {
              ...this.state.selectedNodes,
              [selectedTab]: [...tempSelection],
            },
          }), () => {
            this.createSelectionsRange(selectedTab);
          });
        }
      } else {
        let tempSelection = [...selectedNodesList, node];
        const parentId = node.pid.substr(0, node.pid.lastIndexOf('.'));
        if (parentId.includes('.')) {
          const indexOfSelectedNode = _.findIndex(allGeoNodesToCompare[slectedTabVal],
            el => el.pid === node.pid);
          const nodesToSelect = allGeoNodesToCompare[slectedTabVal]
            .filter(el => (el.pid === parentId ||
              el.pid === parentId.substr(0, parentId.lastIndexOf('.'))));
          const childNodeList = _.filter(tempSelection, el => el.pid.includes(parentId));
          const draggedChildNodes = geographicsTableData[selectedTab]
            .filter(el => el.pid.startsWith(parentId));
          const totalSelectedAndDragged = [...childNodeList,
          ...draggedChildNodes];
          const parentNode = nodesToSelect.find(el => el.pid === parentId);
          if (parentNode.s.length === totalSelectedAndDragged.length) {
            tempSelection = [parentNode, ...tempSelection];
          }
          const secChildNodeList = _.filter(tempSelection, el => {
            return (el.pid.split('.').length === 2 &&
              el.pid.includes(parentId.substr(0, parentId.lastIndexOf('.'))));
          });
          const draggedGrandChildNodes = draggedParentNodes[selectedTab]
            .filter(el => el.pid.split('.').length === 2 &&
              el.pid.includes(parentId.substr(0, parentId.lastIndexOf('.'))));
          const totalGrandSelectedAndDragged = [...secChildNodeList,
          ...draggedGrandChildNodes];
          const secParentNode = nodesToSelect.find(
            el => el.pid === parentId.substr(0, parentId.lastIndexOf('.')));
          if (secParentNode.s.length === totalGrandSelectedAndDragged.length) {
            tempSelection = [secParentNode, ...tempSelection];
          }
          this.setState(() => ({
            shiftSelectedNode: [],
            baseNodeId: indexOfSelectedNode,
            lastNodeId: indexOfSelectedNode,
            firstSelectedNode: { ...node },
            lastSelectedNode: { ...node },
            selectedNodes: {
              ...this.state.selectedNodes,
              [selectedTab]: [...tempSelection],
            },
          }), () => {
            this.createSelectionsRange(selectedTab);
          });
        } else {
          tempSelection = [...selectedNodesList, node];
          const indexOfSelectedNode = _.findIndex(allGeoNodesToCompare[slectedTabVal],
            el => el.pid === node.pid);
          const parentNode = _.find(allGeoNodesToCompare[slectedTabVal],
            el => el.pid === parentId);
          if (parentNode) {
            const childNodeList = _.filter(tempSelection,
              el => el.pid.split('.').includes(parentNode.pid));
            const alreadyDragged = _.filter(geographicsTableData[selectedTab],
              el => (el.pid.startsWith(parentNode.pid) && el.pid !== parentNode.pid));
            const selectedAfterDragged = [...childNodeList, ...alreadyDragged];
            if (parentNode.s.length === selectedAfterDragged.length) {
              tempSelection = [parentNode, ...tempSelection];
            }
          }
          this.setState(() => ({
            baseNodeId: indexOfSelectedNode,
            lastNodeId: indexOfSelectedNode,
            firstSelectedNode: { ...node },
            lastSelectedNode: { ...node },
            shiftSelectedNode: [],
            selectedNodes: {
              ...this.state.selectedNodes,
              [selectedTab]: [...tempSelection],
            },
          }), () => {
            this.createSelectionsRange(selectedTab);
          });
        }
      }
    }
  }

  getDraggedItems = selectedTabVal => {
    const selectedParentNodes = _.filter(this.state.selectedNodes[selectedTabVal],
      el => el.f !== undefined).slice(0, 11);
    const draggedNodes = removeDuplicates(selectedParentNodes);
    return [...draggedNodes];
  }

  handleSelect = e => {
    this.props.geoMappingActions.updateSelectedGeographicsTab(e);
    const selectedGeographicsTabValue = SELECT_GEOGRAPHICS_TAB_OPTIONS[e].value;
    const selectAllLabel = this.getGeographyName(selectedGeographicsTabValue);
    this.setState({
      // selectedGeographicsTabIndex: e,
      selectAllLabel,
      selectedNodes: INITIAL_SELECTED_NODE_STATE,
      localGeographiesCount: INITIAL_GEOGRAPHIES_COUNT,
      // ctrlSelectedRange: [],
      // ctrlSelectedNode: [],
      // selectedNodeRange: [],
      baseNodeId: -1,
      lastNodeId: -1,
      // baseParentNode: -1,
      firstSelectedNode: -1,
      lastSelectedNode: -1,
      shiftSelectedNode: [],
    });
  };

  isSelectAllChecked = selectedTab => {
    const { localGeographiesCount } = this.state;
    const {
      geographicsTableData,
      countyCategorySelectedVal,
      zipcodeCategorySelectedVal,
      geographicsCount,
    } = this.props;
    let selectedTabVal = selectedTab;
    const selectedLeafNodesCount = localGeographiesCount[selectedTabVal];
    let totalNodesCount = geographicsCount[selectedTab];
    if (selectedTab === 'county' || selectedTab === 'zipcode') {
      selectedTabVal = selectedTabVal === 'county' ?
        countyCategorySelectedVal : zipcodeCategorySelectedVal;
      totalNodesCount = selectedTab === 'county' ? geographicsCount.countyByMarket :
        geographicsCount.zipcodeByMarket;
    }
    const draggedData = [...geographicsTableData[selectedTab]].length;
    const afterDraggedDataLength = selectedLeafNodesCount + draggedData;
    const selectedAndDragged = selectedLeafNodesCount + draggedData;
    if ((selectedLeafNodesCount === totalNodesCount) ||
      (draggedData === totalNodesCount) ||
      (afterDraggedDataLength === totalNodesCount) ||
      (selectedAndDragged === totalNodesCount)) {
      return true;
    }
    return false;
  }

  deleteAllRows = geographicsTabIndex => {
    const geographicsTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[geographicsTabIndex].value;
    const updatedGeographyData = [];
    const updatedGeographicsTableApiQueues = [];
    let spIdsToDelete = [];
    if (geographicsTab === 'county' || geographicsTab === 'zipcode') {
      const { geographicsTableData } = this.props;
      spIdsToDelete = geographicsTableData[geographicsTab].map(el => {
        return {
          sp: el.sp,
        };
      });
      updateChildrenCounter(geographicsTab, spIdsToDelete, true,
        this.props.parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
    }
    const payload = {
      selectedTabVal: geographicsTab,
      updatedGeographyData,
      updatedGeographicsTableApiQueues,
    };
    this.props.geoMappingActions.deleteGeographiesTableData(payload);
  };

  deleteRows = (selectedRows, selectedSpIds) => {
    const { geographicsTableData, selectedGeographicsTabIndex,
      geographicsTableApiQueues,
    } = this.props;
    const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
      .value;
    const selectedTabVal = selectedTab;
    const { selectedNodes } = this.state;
    let updatedGeographyData = geographicsTableData[selectedTabVal];
    let updatedSelectedNodes = selectedNodes[selectedTabVal];
    const updatedGeographicsTableApiQueues = _.cloneDeep(geographicsTableApiQueues[selectedTabVal]);
    const updatedSpIds = selectedSpIds.map(el => ({ sp: el }));

    selectedRows.forEach(rowPid => {
      updatedGeographyData = updatedGeographyData.filter(
        item => item.pid !== rowPid
      );
    });

    selectedRows.forEach(rowPid => {
      if (selectedTabVal === 'zipcodeByState') {
        updatedSelectedNodes = updatedSelectedNodes.filter(
          item => item.pid !== rowPid.split('.')[0] &&
            item.pid !== rowPid.split('.').slice(0, 2).join('.')
        );
      } else {
        updatedSelectedNodes = updatedSelectedNodes.filter(
          item => item.pid !== rowPid.split('.')[0]
        );
      }
    });
    if (selectedTab === 'county' || selectedTab === 'zipcode') {
      updateChildrenCounter(selectedTabVal, updatedSpIds, true,
        this.props.parentChildCountMap, this.props.geoMappingActions.setParentChildCountMapThunk);
    }
    selectedRows.forEach(rowPid => {
      updatedGeographicsTableApiQueues.forEach((item, index) => {
        const delRowindex = item.rowPathIds.findIndex(pid => pid === rowPid);
        item.rowExpressionList.splice(delRowindex, delRowindex !== -1 ? 1 : 0);
        item.rowHeaderList.splice(delRowindex, delRowindex !== -1 ? 1 : 0);
        item.rowPathIds.splice(delRowindex, delRowindex !== -1 ? 1 : 0);
        if (item.rowPathIds.length === 0) {
          updatedGeographicsTableApiQueues.splice(index, 1);
        }
      });
    });

    updatedGeographyData = addIndexToGeoMapData(updatedGeographyData)

    const payload = {
      selectedTabVal,
      updatedGeographyData,
      updatedGeographicsTableApiQueues,
    };
    this.props.geoMappingActions.deleteGeographiesTableData(payload);
    this.setState({
      selectedNodes: {
        ...this.state.selectedNodes,
        [selectedTabVal]: [...updatedSelectedNodes],
      },
    });
  }

  handleSort = (sortOrder, sortKey, sortColumnIndex) => {
    const {
      selectedGeographicsTabIndex,
      geographicsSortOrder,
    } = this.props;
    const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
      .value;
    const selectedTabVal = selectedTab;
    const sortObj = {
      sortOrder,
      sortKey,
      sortColumnIndex,
    };
    let updatedGeographicsSortOrder = _.cloneDeep(geographicsSortOrder[selectedTabVal]);
    updatedGeographicsSortOrder = sortObj;
    const payload = {
      selectedTabVal,
      updatedGeographicsSortOrder,
    };
    this.props.geoMappingActions.updateGeoMapGrid(payload);
  }


  render() {
    const { selectedGeographicsTabIndex } = this.props;
    const { isLoading } = this.state;
    return (
      <div
        className="expanded large-12 geomapreport-geoghraphics-category-block geoGridCustomspinner"
        data-test="geomapGeographyListBlock"
      >
        <div className="geomap-heading-label">{SELECT_GEOGRAPHICS_LABEL}</div>
        <div data-test="MediaVehiclesComp" className="GeomapTabDiv">
          <div className="large-12 medium-12 small-12 columns geographicsTab">
            <DynamicTabs
              data-list="DynamicTabsComp"
              styles={{ width: '20%', textAlign: 'center' }}
              selectedIndex={selectedGeographicsTabIndex}
              tabs={[
                {
                  title: SELECT_GEOGRAPHICS_TAB_OPTIONS[0].label,
                  content: this.renderSelectGeographicsTabData(
                    SELECT_GEOGRAPHICS_TAB_OPTIONS[0],
                    0
                  ),
                },
                {
                  title: SELECT_GEOGRAPHICS_TAB_OPTIONS[1].label,
                  content: this.renderSelectGeographicsTabData(
                    SELECT_GEOGRAPHICS_TAB_OPTIONS[1],
                    1
                  ),
                },
                {
                  title: SELECT_GEOGRAPHICS_TAB_OPTIONS[2].label,
                  content: this.renderSelectGeographicsTabData(
                    SELECT_GEOGRAPHICS_TAB_OPTIONS[2].label
                  ),
                },
                {
                  title: SELECT_GEOGRAPHICS_TAB_OPTIONS[3].label,
                  content: this.renderSelectGeographicsTabData(
                    SELECT_GEOGRAPHICS_TAB_OPTIONS[3].label
                  ),
                },
                {
                  title: SELECT_GEOGRAPHICS_TAB_OPTIONS[4].label,
                  content: this.renderSelectGeographicsTabData(
                    SELECT_GEOGRAPHICS_TAB_OPTIONS[4].label
                  ),
                },
              ]}
              handleSelect={this.handleSelect}
            />
          </div>
          <div className="large-5 medium-5 small-5 columns">&nbsp; </div>
        </div>
        <Modal
          title="Are you sure?"
          dialogStyles={removeGeoMapPillModal.dialogStyles}
          ref={node => {
            removeGeoMapPillModal.ref = node;
          }}
        >
          <div className="columns">
            <div className="row">
              This will remove all geographies from the corresponding table.
            </div>
            <div className="row margin-top-20">
              <div className="columns small-6 text-center">
                <GenericButton
                  name="OK"
                  btnStyle="button width-75"
                  onBtnClick={() => {
                    removeGeoMapPillModal.ref.hide();
                    this.deleteAllRows(removeGeoMapPillModal.pillToDelete);
                  }}
                />
              </div>
              <div className="columns small-6 text-center">
                <GenericButton
                  name="Cancel"
                  btnStyle="button width-75"
                  onBtnClick={() => removeGeoMapPillModal.ref.hide()}
                />
              </div>
            </div>
          </div>
        </Modal>
        {isLoading ? <CustomSpinner /> : null}
      </div>
    );
  }
}


GeoMapViewer.propTypes = {
  geoMappingActions: PropTypes.shape({
    getGeoghrapicsData: PropTypes.func,
    updateSelectedGeographicsTab: PropTypes.func,
    updateParentDraggedNodes: PropTypes.func,
    setGeoghrapicsTableDataWithZeros: PropTypes.func,
    setGeoghrapicsApiQueues: PropTypes.func,
    getGeoghrapicsTableData: PropTypes.func,
    deleteGeographiesTableData: PropTypes.func,
    setParentChildCountMapThunk: PropTypes.func,
    updateGeoMapGrid: PropTypes.func,
    setGeoghrapicsTableApiCallStatus: PropTypes.func,
  }),
  activeAccountId: PropTypes.number,
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
    }),
  }),
  selectedGeographicsTabIndex: PropTypes.number,
  zipcodeCategorySelectedVal: PropTypes.string,
  countyCategorySelectedVal: PropTypes.string,
  geoMapStudy: PropTypes.instanceOf(Object),
  geographicsData: PropTypes.instanceOf(Object),
  geoMapTarget: PropTypes.instanceOf(Array),
  geoMapBase: PropTypes.instanceOf(Array),
  geographicsTableData: PropTypes.instanceOf(Object),
  draggedParentNodes: PropTypes.instanceOf(Object),
  geoWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
  }),
  geographicsTableApiQueues: PropTypes.instanceOf(Object),
  parentChildCountMap: PropTypes.instanceOf(Object),
  allGeoNodesToCompare: PropTypes.instanceOf(Object),
  geographicsCount: PropTypes.instanceOf(Object),
  originalTitles: PropTypes.instanceOf(Object),
  geographicsSortOrder: PropTypes.shape({
    selectedTab: PropTypes.shape({
      sortOrder: PropTypes.string,
      sortKey: PropTypes.string,
      sortColumnIndex: PropTypes.number,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    selectedGeographicsTabIndex: state.geomap.selectedGeographicsTabIndex,
    geoMapStudy: state.study.geoMapStudy,
    countyCategorySelectedVal: state.geomap.countyCategorySelectedVal,
    zipcodeCategorySelectedVal: state.geomap.zipcodeCategorySelectedVal,
    geographicsData: state.geomap.geographicsData,
    geoMapBase: state.geomap.BaseDataGridData,
    geoMapTarget: state.geomap.TargetDataGridData,
    geographicsTableData: state.geomap.geographicsTableData,
    geoWeightTypes: state.study.geoWeightTypes,
    draggedParentNodes: state.geomap.draggedParentNodes,
    geographicsTableApiQueues: state.geomap.geographicsTableApiQueues,
    parentChildCountMap: state.geomap.parentChildCountMap,
    allGeoNodesToCompare: state.geomap.allGeoNodesToCompare,
    originalTitles: state.geomap.originalTitles,
    geographicsSortOrder: state.geomap.geographicsSortOrder,
    geographicsCount: state.geomap.geographicsCount,
  };
}


function mapDispatchToProps(dispatch) {
  return {
    geoMappingActions: bindActionCreators(geoMappingActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GeoMapViewer);
